import { CommentAction, CommentActions } from '../actions/comment.actions';
import { CommentState } from '../state/comment.state';

export const initialCommentState: CommentState = {
    comments: [],
    error: null,
};
export function commentReducer(
    state = initialCommentState,
    action: CommentAction
) {
    switch (action.type) {
        case CommentActions.GetCommentsSuccess:
            return {
                ...state,
                comments: action?.payload?.data,
            };
        case CommentActions.GetCommentsFailure:
            return {
                ...state,
                error: action?.payload,
            };
        case CommentActions.GetTransactionComments:
            return {
                ...state,
            };
        default:
            return state;
    }
}
